// Vendors
import { IconComponent } from '@openbank/ziniaweb-ui-components';
import React from 'react';
// Constants
import { CANCEL_DROP_MODAL_CLOSE_COMPONENT_PROPS } from 'components/cancel-drop-modal/components/close/constants/cancel-drop-modal-close.constants';
// Types
import { CancelDropModalComponentType } from 'components/cancel-drop-modal/types/cancel-drop-modal.component.type';

const CancelDropModalCloseComponent = ({
  onClose,
}: Pick<CancelDropModalComponentType, 'onClose'>): React.JSX.Element => (
  <IconComponent {...CANCEL_DROP_MODAL_CLOSE_COMPONENT_PROPS} onClick={onClose} />
);

export { CancelDropModalCloseComponent };
